import { FaGlobe, FaApple, FaAmazon, FaWeibo, FaWeixin, FaYandexInternational  } from 'react-icons/fa';
import {
  SiWhatsapp,
  SiTelegram,
  SiFacebook,
  SiInstagram,
  SiTwitter,
  SiTiktok,
  SiLinkedin,
  SiYoutube,
  SiSnapchat,
  SiSkype,
  SiDiscord,
  SiViber,
  SiGoogle,
  SiGmail,
  SiNetflix,
  SiUber,
  SiAirbnb,
  SiPaypal,
  SiReddit,
  SiTwitch,
  SiSpotify,
  SiLine,
  SiKakao,
  SiSignal,
  SiShopify,
  SiOpenai,
  SiCoinbase,
  SiBinance,
  SiEbay,
  SiMicrosoft,
  SiSteam,
  SiTinder,
  SiVk,
  SiVenmo,
  SiApple 
} from 'react-icons/si';

const serviceIconMap = {
  whatsapp: SiWhatsapp,
  telegram: SiTelegram,
  facebook: SiFacebook,
  instagram: SiInstagram,
  twitter: SiTwitter,
  tiktok: SiTiktok,
  linkedin: SiLinkedin,
  youtube: SiYoutube,
  snapchat: SiSnapchat,
  skype: SiSkype,
  discord: SiDiscord,
  viber: SiViber,
  wechat: FaWeixin,
  google: SiGoogle,
  gmail: SiGmail,
  amazon: FaAmazon ,
  apple: FaApple,
  netflix: SiNetflix,
  uber: SiUber,
  airbnb: SiAirbnb,
  paypal: SiPaypal,
  reddit: SiReddit,
  twitch: SiTwitch,
  spotify: SiSpotify,
  line: SiLine,
  kakao: SiKakao,
  signal: SiSignal,
  shopify: SiShopify,
  openai: SiOpenai,
  coinbase: SiCoinbase,
  binance: SiBinance,
  ebay: SiEbay,
  microsoft: SiMicrosoft,
  steam: SiSteam,
  tinder: SiTinder,
  vk: SiVk,
  venmo: SiVenmo,
  yandex: FaYandexInternational,
  weibo: FaWeibo
};

const serviceCodeMap = {
  fb: SiFacebook,
  ig: SiInstagram,
  tw: SiTwitter,
  wa: SiWhatsapp,
  wb: FaWeixin,
  vk: SiVk,
  tg: SiTelegram,
  yt: SiYoutube,
  mt: SiMicrosoft,
  dm: SiDiscord,
  tx: SiTiktok,
  tt: SiTiktok,
  pp: SiPaypal,
  gm: SiGmail,
  am: FaAmazon ,
  ap: SiApple,
  nb: SiNetflix,
  gl: SiGoogle,
  ms: SiMicrosoft,
  vk: SiVk,
  yn: FaYandexInternational,
  wi: FaWeibo
};

const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ' ');

export const getServiceIcon = (name, code) => {
  const normalizedName = normalize(name);
  const normalizedCode = String(code || '').toLowerCase();

  const foundNameKey = Object.keys(serviceIconMap).find((key) => normalizedName.includes(key));
  if (foundNameKey) return serviceIconMap[foundNameKey];

  const foundCodeKey = Object.keys(serviceCodeMap).find((key) => normalizedCode === key || normalizedName.includes(key));
  if (foundCodeKey) return serviceCodeMap[foundCodeKey];

  return FaGlobe;
};
